export default __webpack_public_path__ + "osprey_floodlight.40ba5f08.png";